import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './mixins/locales'
import TurbolinksAdapter from 'vue-turbolinks'
import googleAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: '737952827884-o4nqsfbhf0sgeagti346p3f0cm6qeocg.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(VueI18n)
Vue.use(TurbolinksAdapter)
Vue.use(googleAuth, gauthOption)



window.i18n = new VueI18n({
  locale: 'es',
  messages
})

window.Vue = Vue
